module.exports = __webpack_public_path__ + "img/owl.629a0d7.png";